import React from "react";
import { RouteComponentProps } from "react-router-dom";

export const Home = ({ history }: RouteComponentProps) => {
  return <h2>Home Page</h2>;
};
